import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Divider, Modal, Row, Icon } from 'antd';
import { connect } from 'react-redux';
import { NavLink, Redirect, withRouter } from 'react-router-dom';
import getFormData from 'get-form-data';
import axios from 'axios';
import moment from 'moment-timezone';
import './authorization.less';

import { getUserToken } from '@features/userTokenSlice';
import notification from '@helps/notification';
import Wrapper from '@molecules/wrappers/RobotWrapper';
import RegistrationBlockWrapper from '@molecules/wrappers/RegistrationBlockWrapper';
import verificationController from '@common/controllers/verification';
import { TfaChooseMethod, TfaQrForm } from '@organisms/personal-profile/ProfileTfa';

import { fieldValidation, fieldBlur, fieldChange, responseError } from 'FIELDS';
import { InputsSet, RadioSet, PasswordSet } from 'INPUTS';
import api from 'API';
import defaults from 'DEFAULTS';
import { Strings } from 'HELPERS';
import OAuthPopup from '@templates/authorization/OAuthPopup';
import { fetchAllPersonalData } from '@features/personalSlice';
import TfaQrFormPreregistration from '@organisms/personal-profile/ProfileTfa/TfaQrFormPreregistration';
import { fetchAllCurrencies } from '@features/currencySlice';

class Authorization extends Component {
  constructor(props) {
    super(props);

    this.state = {
      personalDataLoaded: true,
      loading: false,
      counter: 0,
      attemptKey: 'authAttempt',
      attemptWaitingKey: 'authWaiting',
      data: {},
      visible: false,
      type: {
        name: 'type',
        value: 'company',
        label: false,
        keys: [],
      },
      email: {
        name: 'email',
        type: 'email',
        required: true,
        autoComplete: 'email',
        placeholder: true,
        description: false,
      },
      password: {
        name: 'password',
        type: 'password',
        autoComplete: 'current-password',
        required: true,
        placeholder: true,
      },
      isTfaVerification: false,
      preferred_2fa: null,
      tfa_google: null,
      tfa_phone: null,
      resultLogin: null,
    };

    this._mounted = false;

    this.fieldChange = fieldChange.bind(this, this);
    this.handleFieldBlur = fieldBlur.bind(this, this);
    this.fieldValidation = fieldValidation.bind(this, this);
    this.responseError = responseError.bind(this, this);

    this.handleFieldChange = this.handleFieldChange.bind(this, this);
    this.getUserTypes = this.getUserTypes.bind(this);
    this.isAccountType = this.isAccountType.bind(this);
    this.multipleAccountTypes = this.multipleAccountTypes.bind(this);
    this.successLogin = this.successLogin.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.failureLogin = this.failureLogin.bind(this);
    this.cancelTfa = this.cancelTfa.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    sessionStorage.clear();

    if (this.isAccountType() && this.multipleAccountTypes()) {
      this.getUserTypes();
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleFieldChange(context, item) {
    if (item.name === 'type') {
      this.props.history.push(`/${item.value}`);
    }

    fieldChange(context, item);
  }

  getUserTypes() {
    const { t, userType } = this.props;
    const { type } = this.state;
    const userTypeKeys = defaults.variables.account_types.map((type) =>
      t('keys.account_types').find((item) => item.value === type)
    );

    if (this._mounted) {
      this.setState({
        type: {
          ...type,
          keys: userTypeKeys.reverse(),
          value: userType,
        },
      });
    }
  }

  isAccountType() {
    const { userType } = this.props;
    return defaults.variables.account_types.includes(userType);
  }

  multipleAccountTypes() {
    return defaults.variables.account_types.length > 1;
  }

  async successLogin(loginResponse) {
    const { userType, getUserToken, fetchAllPersonalData, fetchAllCurrencies } = this.props;

    if (loginResponse?.data?.token) {
      this.setState({ personalDataLoaded: false });
      getUserToken({
        ...loginResponse.data,
        tokenType: userType,
        isLogged: true,
      });
      // await fetchAllPersonalData();
      await fetchAllCurrencies();

      this.setState({ personalDataLoaded: true });
    }

    if (loginResponse?.access_token?.token) {
      this.setState({ personalDataLoaded: false });
      const userType = loginResponse?.user?.type;
      this.props.history.push(`/${userType}`);
      getUserToken({
        ...loginResponse.access_token,
        tokenType: userType,
        isLogged: true,
      });
      // await fetchAllPersonalData();
      await fetchAllCurrencies();

      this.setState({ personalDataLoaded: true });
    }
  }

  success2faLogin() {
    this.successLogin(this.state.resultLogin);
  }

  async handleSubmit(event) {
    event.preventDefault();

    const { attemptKey, attemptWaitingKey } = this.state;
    const { userType, t } = this.props;
    const blockedUntil = localStorage.getItem(attemptWaitingKey);

    // Forbid form submission for 15 minutes
    // Due to incorrect login attempts
    if (blockedUntil && moment().isBefore(new Date(blockedUntil))) {
      this.renderLockTimeMessage();

      return false;
    }

    if (this.fieldValidation() && this._mounted) {
      let data = getFormData(event.target, { trim: true });

      try {
        const result = await axios(api.users.authorization.login(userType).AXIOS('POST', data));
        this.setState({ resultLogin: result });
        sessionStorage.setItem('magma-token', result.data.token_magma);
        const methods = t('keys.tfa');
        const isTfa = result.data.tfa_magma?.preferred_2fa;
        // result.data.hasOwnProperty('preferred_2fa') &&
        // methods.some((method) => result.data.hasOwnProperty(method.value) && result.data[method.value]);

        localStorage.removeItem(attemptKey);
        localStorage.removeItem(attemptWaitingKey);

        if (isTfa) {
          return this.setState({
            isTfaVerification: true,
            preferred_2fa: result.data.tfa_magma.preferred_2fa,
            tfa_google: result.data.tfa_magma.tfa_google,
            tfa_phone: result.data.tfa_magma.tfa_phone,
          });
        } else {
          // If the token is returned, then redirect to the personal account
          await this.successLogin(result);
        }
      } catch (error) {
        if (error?.response?.status === 409) {
          this.setState({ visible: true });
        } else {
          responseError(this, error);
        }

        this.failureLogin(error);
      } finally {
        this.setState({ loading: false });
      }
    }
  }

  failureLogin(error) {
    if (error.response && error.response.status < 500) {
      this.attemptResetCounter();
    }
  }

  attemptResetCounter() {
    const { attemptWaitingKey, attemptKey } = this.state;
    let attempt = localStorage.getItem(attemptKey);

    // check the number of attempts
    if (attempt) {
      attempt = parseInt(attempt) + 1;

      localStorage.setItem(attemptKey, JSON.stringify(attempt));

      if (attempt >= 3) {
        localStorage.removeItem(attemptKey);
        localStorage.setItem(attemptWaitingKey, JSON.stringify(moment().add(15, 'minutes')));
      }
    } else {
      localStorage.setItem(attemptKey, JSON.stringify(1));
    }
  }

  cancelTfa() {
    this.setState({
      isTfaVerification: false,
      preferred_2fa: null,
      tfa_google: null,
      tfa_phone: null,
    });
  }

  renderLockTimeMessage() {
    const { t } = this.props;

    notification(
      {
        ...t('notification.authLocked'),
        description: Strings.Compile(t('notification.authLocked.description'), [
          moment(new Date(localStorage.getItem(this.state.attemptWaitingKey))).fromNow(),
        ]),
      },
      'warn'
    );
  }

  renderBlockDescription(description) {
    return description.split('\n').map((line, index, array) => (
      <React.Fragment key={index}>
        {line}
        {index < array.length - 1 ? <br /> : ''}
      </React.Fragment>
    ));
  }

  renderLoginForm() {
    const { route, t } = this.props;
    const { loading, visible } = this.state;
    const isClient = this.isAccountType();

    return (
      <>
        <h1 className={'align-center'} style={{ marginBottom: '20px' }}>
          Log in
        </h1>
        {/*<h1 className={'align-center'} style={{ marginBottom: '20px', color: 'red' }}>*/}
        {/*  <div className={'maintenance'}>*/}
        {/*    <div> The login page is currently undergoing unscheduled maintenance.</div>*/}
        {/*    <div> We apologize for any inconvenience caused.</div>*/}
        {/*  </div>*/}
        {/*</h1>*/}
        <p style={{ marginBottom: '40px' }} className={'align-center'}>
          👋 It is great to see you back! Please log in.
        </p>
        <Form onSubmit={this.handleSubmit}>
          {isClient && <div className={'fields'}>{RadioSet(this, ['type'])}</div>}
          <div className={'fields'}>
            {InputsSet(this, ['email'])}
            {PasswordSet(this, ['password'])}

            {/*{isClient && (*/}
            {/*  <NavLink to={`${route}/registration/verification/email`} className={'link'}>*/}
            {/*    <Icon type={'user-add'} />*/}
            {/*    <span className={'link'}>{t('button.newAccount')}</span>*/}
            {/*  </NavLink>*/}
            {/*)}*/}
          </div>
          <Button htmlType={'submit'} type={'primary'} size={defaults.antd.button.size} loading={loading} block>
            {t('button.logIn')}
          </Button>
          <Modal
            onCancel={() => this.setState({ visible: false })}
            visible={visible}
            title={t('page.blockTitle')}
            footer={null}
          >
            <Form>
              <h3>{this.renderBlockDescription(t('page.blockDescription'))}</h3>
              <Row md={12}>
                <Button
                  onClick={() => this.setState({ visible: false })}
                  type={'primary'}
                  size={defaults.antd.button.size}
                  loading={loading}
                  block
                >
                  {t('button.ok')}
                </Button>
              </Row>
            </Form>
          </Modal>
        </Form>

        <OAuthPopup successCallback={this.successLogin} route={route} />
      </>
    );
  }

  renderTfaForm() {
    const { userType, t } = this.props;
    const { email, password, preferred_2fa, tfa_google, tfa_phone } = this.state;

    return (
      <div className={'tfa'}>
        <TfaQrFormPreregistration
          userType={userType}
          email={email}
          password={password}
          successCallback={() => this.success2faLogin()}
        />

        <Divider />

        <div className={'tfa_back'}>
          <Button type={'primary'} size={defaults.antd.button.size} block onClick={this.cancelTfa}>
            {t('button.backToLogin')}
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { personalDataLoaded, isTfaVerification } = this.state;
    const { userType, userToken, redirectRoute } = this.props;
    const verificationPages = ['aemi'].indexOf(userType) >= 0;

    if (defaults.isAuthorized(userType) && personalDataLoaded) {
      // if (!userToken.status && !verificationPages) {
      //   verificationController(redirectRoute, null, (result) => {
      //     if (result.redirect) {
      //       return <Redirect to={result.redirect} />;
      //     }
      //   });
      // }

      return <Redirect to={redirectRoute} />;
    }

    return (
      <Wrapper isLogin={true}>
        <RegistrationBlockWrapper userType={userType}>
          <>{isTfaVerification ? this.renderTfaForm() : this.renderLoginForm()}</>
        </RegistrationBlockWrapper>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ userToken }) => {
  return {
    userToken: userToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserToken: (value) => dispatch(getUserToken(value)),
    fetchAllPersonalData: () => dispatch(fetchAllPersonalData()),
    fetchAllCurrencies: () => dispatch(fetchAllCurrencies()),
    // fetchAllAclData: () => dispatch(fetchAllAclData()),
    // fetchAllUserLevels: () => dispatch(fetchAllUserLevels()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Authorization));

Authorization.propTypes = {
  redirectRoute: PropTypes.string.isRequired,
  userType: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  userToken: PropTypes.object.isRequired,
  getUserToken: PropTypes.func.isRequired,
  fetchAllPersonalData: PropTypes.func,
  fetchAllCurrencies: PropTypes.func,
  fetchAllAclData: PropTypes.func,
  fetchAllUserLevels: PropTypes.func,
  t: PropTypes.func.isRequired,
};
